<script>
export default {
  name: 'menuTitleTip',
  props: {
    text: String,
    top: Number
  },
  render(h) {
    return h(
      'div',
      {
        attrs: {
          class: 'ui-menu-fold-tooltip'
        },
        style: {
          top: this.top + 'px'
        }
      },
      this.text
    )
  }
}
</script>
<style lang="stylus">
.ui-menu-fold-tooltip
  position absolute
  transform translateY(-50%)
  font-size 14px
  padding 2px 6px
  background #fff
  transition top 0.3s
  white-space nowrap
  box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)

  &:before
    content ''
    position absolute
    top 50%
    transform translateY(-50%)
    left -16px
    width 0
    height 0
    border 8px solid transparent
    border-right 8px solid #fff
</style>